
<template>
  <van-popup
    v-model="show"
    :overlay="false"
    z-index="2"
    position="bottom"
    :style="{ height: '100vh' }"
    :lock-scroll="false"
  >
    <div class="wrapper">
      <div class="block">
        <div class="button-close" @click="onCloseClick()">
          <img
            style="height: 19px"
            :src="require('../../../assets/imgs/icon/bottom-modal-close.png')"
          />
        </div>

        <div class="content-container">
          <div
            class="question-item-container"
            v-for="(item, index) in quizData.questions"
            :key="index"
          >
            <div class="question-item-index">{{ index + 1 }}.</div>
            <div class="question-item-title">
              <div>
                {{ item.title }}
              </div>
              <div class="option-container">
                <div class="option-item-container"  v-for="(option,idx) in item.options" :key="option.optionId">
                  <div :class="getOptionLabelClass(index,option)">
                    {{OPTION_LABELS[idx]}}
                  </div>
                  <div :class="getOptionContentClass(index,option)">
                  {{ option.title }}

                  </div>
                </div>
              </div>
              <!-- <div
                class="question-option-select"
                v-if="answer[index] && answer[index].optionId"
                @click="onQuizSelect(index)"
              >
                {{ `已选${formatOptionLabel(index)}` }}
              </div>
              <div
                class="question-option-unselect"
                v-else
                @click="onQuizSelect(index)"
              >
                {{ `未选` }} -->
              </div>
            </div>
          </div>

          <div style="height: 50px; background-color: #fff"></div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import * as ActionTypes from "../../../store/action-types";
import { mapState } from "vuex";
export default {
  name: "ArticleReviewModal",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      answer: (state) => state.article.answer,
      quizData: (state) => state.article.quizData,
    }),
  },
  data() {
    return {
      OPTION_LABELS: ["A", "B", "C", "D","E", "F", "G", "H"],

      //   show: true,
    };
  },
  watch: {},
  methods: {
    onCloseClick() {
      this.onClose();
    },
    formatOptionLabel(index) {
      let answerOpt = this.answer[index].optionId;
      let optionIndex = _.findIndex(
        this.quizData.questions[index].options,
        function (o) {
          return o.optionId == answerOpt;
        }
      );
      console.log(optionIndex);
      return this.OPTION_LABELS[optionIndex];
    },
    getOptionLabelClass(questionIndex, option) {
      // let optionIndex = _.findIndex(this.quizData.questions[index].options, function (o) {
      //   return o.optionId == answerOpt;
      // });
      let answerOpt = this.answer[questionIndex].optionId;
      // let isCorrect = answerOpt == optionId;
      if (option.isCorrect) {
        return "option-label-correct"
      } else {
        return answerOpt == option.optionId
          ? "option-label-incorrect"
          : "option-label-normal";
      }
    },
    getOptionContentClass(questionIndex, option) {
      let answerOpt = this.answer[questionIndex].optionId;
      // let isCorrect = answerOpt == optionId;
      if (option.isCorrect) {
        return "option-content-correct";
      } else {
        return answerOpt == option.optionId
          ? "option-content-incorrect"
          : "option-content-normal";
      }
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #00000066;
}

.block {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  height: 70vh;
  width: 100%;
  padding-bottom: 50px;
  border-radius: 20px 20px 0 0;
}

.content-container {
  height: 100%;
  padding: 15px;
  text-align: left;
  overflow: auto;
}

.article-content-title {
  font-size: 18px;
  color: #333333;
  font-family: serif,SimSun,STSong;
  margin: 5px 0;
  word-wrap: break-word;
}

.article-content-snapshot {
  padding-bottom: 10px;
  font-size: 14px;
}

.article-label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 11px;
  color: #999999;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.9);
}

.text-level-desc {
  margin-top: 10px;
  font-size: 12px;
  transform: scale(0.9);
  color: #333333;
}

.button-close {
  text-align: center;
  margin: 10px;
}

.question-item-container {
  display: flex;
}

.question-item-index {
  text-align: center;
  width: 50px;
  margin-right: 10px;
  font-size: 16px;
  color: #333333;
  // display : flex
}

.question-item-title {
  flex: 1;
  font-size: 14px;
  line-height: 24px;
  flex-direction: column;
}

.question-option-select {
  width: 50%;
  text-align: center;
  margin: 20px 0;
  line-height: 32px;
  border: 1px solid #3994E7;
  color: #3994E7;
  font-size: 14px;
  border-radius: 16px;
}

.question-option-unselect {
  width: 50%;
  text-align: center;
  margin: 20px 0;
  line-height: 32px;
  border: 1px solid #999999;
  color: #999999;
  font-size: 14px;
  border-radius: 16px;
}

.option-container {
  margin: 10px 0;
}

.option-item-container {
  display: flex;
  justify-content: start;
  margin: 8px 0;
}

.option-label-normal {
  width: 32px;
  line-height: 32px;
  height: 32px;
  text-align: center;
  color: #333333;
  border-radius: 16px;
  font-size: 18px;
  font-weight: bold;
}

.option-label-correct {
  width: 32px;
  line-height: 32px;
  height: 32px;
  text-align: center;
  color: #ffffff;
  background: linear-gradient(top, #98CEFF, #3994E7);
  border-radius: 16px;
  font-size: 18px;
  font-weight: bold;
}

.option-label-incorrect {
  width: 32px;
  line-height: 32px;
  height: 32px;
  text-align: center;
  color: #ffffff;
  background: #F34C4C;
  border-radius: 16px;
  font-size: 18px;
  font-weight: bold;
}

.option-content-normal {
  flex: 1;
  margin-left: 6px;
  text-align: start;
  line-height: 24px;
  color: #333333;
  font-size: 14px;
  margin-top: 4px;
}

.option-content-correct {
  flex: 1;
  margin-left: 6px;
  text-align: start;
  line-height: 24px;
  margin-top: 4px;
  color: #3994E7;
  font-size: 14px;
}

.option-content-incorrect {
  flex: 1;
  margin-left: 6px;
  margin-top: 4px;
  text-align: start;
  line-height: 24px;
  color: #F34C4C;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/WrongAnswerModal.vue